import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/sign-up")({
	component: SignUpPage,
	ssr: false,
});

function SignUpPage() {
	return <AuthPage view="SIGN_UP" />;
}
